import { Breakpoint } from 'antd/lib/_util/responsiveObserve';
import useScreenSize from './useScreenSize';

type UseResponsiveContentProps = {
  xs?: any;
  sm?: any;
  md?: any;
  lg?: any;
  xl?: any;
  xxl?: any;
};

const breakpoints: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const useResponsiveContent = (content: UseResponsiveContentProps): any => {
  const breakpoint = useScreenSize();

  return getResponsiveContent(content, breakpoint);
};

export const getResponsiveContent = (content: UseResponsiveContentProps, breakpoint: string): string => {
  // Find the closest available content (fallback to smaller breakpoints)
  const currentIndex = breakpoints.indexOf(breakpoint as Breakpoint);

  // eslint-disable-next-line no-plusplus
  for (let i = currentIndex; i >= 0; i--) {
    if (content[breakpoints[i]]) {
      return content[breakpoints[i]];
    }
  }

  return content.xs;
};

export const buildI18KeyResponsive = (ns: string, bp: Breakpoint[]): any =>
  bp.reduce((acc: Partial<Record<Breakpoint, string>>, curr) => {
    acc[curr] = `${ns}.${curr}`;
    return acc;
  }, {});

export default useResponsiveContent;
